module.exports = __webpack_public_path__ + "media/shiva1.434b01c7.webm";